<template>
  <div class="member-periods">
    <el-tabs class="el-tabs-common" v-model="curTab" @tab-click="onTabClick">
      <el-tab-pane
        v-for="(item, index) in tabs"
        :key="index"
        :name="item.name"
        :label="item.label"
      ></el-tab-pane>
    </el-tabs>
    <div style="padding-top: 8px">
      <MemberArrange v-if="curTab == 'otn'" :type="1" :arrange_type="1"></MemberArrange>
      <MemberArrange v-else-if="curTab == 'oto_m'" :type="1" :arrange_type="2"></MemberArrange>
      <MemberArrange v-else-if="curTab == 'class'" :type="2"></MemberArrange>
      <MemberPeriodsRecord
        v-else-if="curTab == 'periods'"
        @showOutLine="showOutLine"
      ></MemberPeriodsRecord>
    </div>
  </div>
</template>
<script>
import MemberArrange from './components/MemberArrange.vue';
import MemberPeriodsRecord from './components/MemberPeriodsRecord.vue';

export default {
  name: 'MemberPeriods',
  components: { MemberArrange, MemberPeriodsRecord },
  async created() {
    await this.getExtra();
    this.judgeCurTab();
  },
  data() {
    return {
      curTab: '',
      extra: {},
    };
  },
  computed: {
    tabs() {
      let tabs = [];
      if (this.extra.has_one_contracts == 1) {
        tabs.push({ name: 'otn', label: '一对一' });
      }
      if (this.extra.has_many_contracts == 1) {
        tabs.push({ name: 'oto_m', label: '一对多' });
      }
      if (this.extra.has_team_contracts == 1) {
        tabs.push({ name: 'class', label: '班课' });
      }
      tabs.push({ name: 'periods', label: '我的课时包' });
      return tabs;
    },
  },
  watch: {
    $route: {
      handler(data) {
        this.curTab = data.query.tab;
      },
    },
  },
  methods: {
    async getExtra() {
      let data = await this.$http.get('/api/app/arrange/list', { type: 1 });
      this.extra = data.extra;
    },
    judgeCurTab() {
      if (this.extra.has_one_contracts == 1) {
        this.curTab = 'otn';
        return;
      }
      if (this.extra.has_many_contracts == 1) {
        this.curTab = 'oto_m';
        return;
      }
      if (this.extra.has_team_contracts == 1) {
        this.curTab = 'class';
        return;
      }
      this.curTab = 'periods';
    },
    onTabClick(tab) {
      this.$router.replace({ name: 'MemberPeriods', query: { tab: tab.name } });
    },
    showOutLine(row) {
      this.$router.push({
        name: 'MemberPeriodsOutline',
        params: { id: row.id },
        meta: { title: '我的约排课' },
        query: {
          id: row.id,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.member-periods {
  padding: 5px 24px 20px 24px;
  background: #fff;
  position: relative;
}
</style>
